import { Box, styled } from "@mui/material";

import { ReactComponent as AttactmentIcon } from "@assets/icons/paperclip.svg";

interface Props {
  fileSelectId: string;
  disabled: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AttachmentInput = ({ fileSelectId, disabled, onChange }: Props) => (
  <Box
    component="label"
    htmlFor={fileSelectId}
    sx={{
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      p: 1,
      mb: 0.5,
      borderRadius: 2.5,
    }}
  >
    <AttactmentIcon />
    <VisuallyHiddenInput
      disabled={disabled}
      onChange={onChange}
      onClick={(event) => {
        event.stopPropagation();
        event.currentTarget.value = null;
      }}
      id={fileSelectId}
      type="file"
      multiple
    />
  </Box>
);

export default AttachmentInput;

const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;
